export const endpoints = {
  authenticate: "/api/idm/v1/login",
  listarInstituicoesRegime: "/api/regimeEspecial/listar",
  resetSenha: "/api/idm/v1/senha",

  termoAceite: "/api/termo-aceite/v1/termo?tipoDocumento=1&status=true",

  listarDdi: "/api/utils/ddi",
  tokenEmail: "/api/idm/v1/tokens",
  validateToken: "/api/idm/v1/tokens/validate",

  cadastro: "/api/idm/v2/usuarios",
  cadastroEmpresa: "/api/empresa/cadastrar",

  listarEmpresas: "/api/empresa/buscar",
  listarSolicitações: "/api/investidores/v2/solicitacoes",
  atualizarSenha: "/api/idm/v1/senha",

  atualizarDadosEmpresa: "/api/empresa/atualizar",
  atualizarDados: "/usuarios",
  atualizarCognito: "/usuarios/confirma-cognito",

  insereEndereco: "/api/garantias/insereEnderecoInvestidor",

  pagamentoInvestidor: "/api/garantias/v2/dadosPagamentoInvestidor",

  listarBancos: "/api/bancos/listar",

  listarCorretoras: "/api/corretoras/listar",

  solicitarGarantia: "/api/garantias/v4/dadosPagamentoInvestidor",
  // solicitarGarantia: "/api/garantias/v2/dadosPagamentoInvestidor",

  // viaCep: 'https://viacep.com.br/ws',

  consultaDisponibilidadeDPGE: "{url-dpge}/api/regimeEspecial/v2/instituicoes",

  verificarDisponibilidadeDPGE:
    "{url-dpge}/api/dpge-garantias/v1/disponibilidade",
  garantiaDPGE: "{url-dpge}/api/dpge-garantias/v1/solicitacoes",

  // garantiaDisponibilidade: "/api/garantias/v1/disponibilidade",
  garantiaDisponibilidade: "/api/garantias/v3/disponibilidade",

  listarUsuarios: "/api/idm/v1/usuarios",

  validateEmail: "/dadosacessoidm/v1/validarCadastroDuplicado",
  acompanharProcesso: "/api/utils/v1/status-garantias",
  acompanharAceite: "/aceite-termo-pj",
  detalhesGarantiaEntidade:
    "{url-dpge}/api/dpge-garantias/v1/entidade/solicitacoes",
  recuperaEnderecoUsuario: "{url-dpge}/api/dpge-garantias/v1/entidade/endereco",
  recuperaCodigoAtivoEntidade:
    "{url-dpge}/api/dpge-garantias/v1/entidade/codigo-ativo",

  updateInvestidor: "{url-dpge}/api/dados-pagamento/v1/dados-investidor",
  updateEntidade: "{url-dpge}/api/dados-pagamento/v1/dados-entidade",
  updateCognito: "/cognito/usuarios/portal-pj",

  garantiaEntidadeDPGE:
    "{url-dpge}/api/dpge-garantias/v1/entidade/solicitacoes",

  garantiaDisponibilidadeEntidade: "/api/",
  updateInvestidorOrdinaria: "/api/garantias/insereDadosParaDeposito",
};
